// Core
import React, { Component } from 'react';
import '../styles/styles.scss';

// Imports
import Spinner from 'react-bootstrap/Spinner';
import Header from '../components/header';
// Pages
import Preferences from '../components/preferences';
import Error from './Error'
import { getCategories } from '../Functions';

class Authenticated extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      data : [],
      categories: [],
      loading : true,
      prefsLoading: true,
      error : false,
      hasResults : false,
      email : this.props.query.email,
      channel : this.props.channel
    }
  }

  async componentDidUpdate() {
    if (this.containerRef.current && !this.state.loading && !this.state.prefsLoading) {
      this.broadcastHeight(this.containerRef.current.offsetHeight);
    }
  }

  manualResize = () => {
    console.log("manual resizing");
    if (this.containerRef.current && !this.state.loading && !this.state.prefsLoading) {
      this.broadcastHeight(this.containerRef.current.offsetHeight);
    }
  }

  async componentDidMount() {
    window.addEventListener('resize', this.manualResize);
    const categories = await Promise.all([
      this.fetchCategories()
    ]);

    const catError = categories == null ? true : false;

    const emailError = this.props.query.email == null ? true : false;

    this.setState({
      email : this.props.query.email,
      additionalEmail : this.props.query.additionalEmail,
      categories : categories
    });

    this.setState({ error : (catError || emailError), loading : false });    
  }

  async componentWillUnmount() {
    return window.removeEventListener('resize', this.manualResize);
  }

  updateFromPrefs = (prefsAreLoading) => {
    if (prefsAreLoading) return;
    this.setState({prefsLoading: false});
  }

  errorFromPrefs = (hasError) => {
    if (hasError) {
      this.setState({error:true, loading:false});
    }
  }

  async broadcastHeight(height) {
    const iframeMessage = {height}
    window.top.postMessage(iframeMessage,"*"); //broadcast iframe height to parent in case embedded
  }

  async fetchCategories() {
    let categories = await getCategories().then(resp => {
      return resp;
    });

    if (categories.data == null || categories.data.err) {
			return null;
    }

    if (categories.data.length) {
      return categories.data;
    }
  }

  render() {
    if (this.state.error) {
      if (this.state.channel === "MOB" || this.state.channel === "OLB") {
        return (
          <>
            <Error message="An Error Occured" subMessage="There was an error looking up the provided email address, please try again later." />
          </>
        );
      } else {
        return (
          <>
            <Header />
            <Error message="An Error Occured" subMessage="There was an error processing your email token, please try again later." />
          </>
        );
      }
    }

    else if (!this.state.loading) {
      return (
        <>
          {this.state.channel === "MOB" || this.state.channel === "OLB" ? <></> : <Header />}
          <div className={this.state.channel === "MOB" || this.state.channel === "OLB" ? "outer-container condensed" : "outer-container"} ref={this.containerRef}>
            <span className="pref-container">
              <Preferences email={this.state.email} categories={this.state.categories} channel={this.state.channel} loadFunc={this.updateFromPrefs} parentError={this.errorFromPrefs} />
            </span>
            { this.state.additionalEmail != null &&
              <span className="pref-container">
                <Preferences email={this.state.additionalEmail} categories={this.state.categories} channel={this.state.channel} />
              </span>
            }
          </div>
        </>
      );
    }

    else {
      return (
        <>
          <Spinner animation="border" role="status" id="spinner" size="sm">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </>
      );
    }
  }
}

export default Authenticated;